module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "smooth-appear",
      rawName: "v-smooth-appear",
      value: ({
        elements: '.smooth-appear-project',
        wait: 1000,
        duration: 600,
        delay: 100,
        translate: 30
      }),
      expression: "{elements: '.smooth-appear-project', wait: 1000, duration: 600, delay: 100, translate: 30}"
    }],
    staticClass: "project-list"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-wrapper smooth-appear-project"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": item.thumbnail
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('h4', {
      staticClass: "subtitle"
    }, [_vm._v("\n          " + _vm._s(item.subtitle) + "\n        ")])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7483cee2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectList.vue
// module id = 158
// module chunks = 1